export default "__VITE_ASSET__C_In6_vT__"